import React from "react";
import {Button} from "@mui/material";

/**
 *
 * @param string
 * @param func
 * @returns {Element}
 * @constructor
 */
const SnackbarCloseButton = ({variant, closeSnackbar}) => {
    const color = variant === 'error' ? 'secondary' : 'primary';
    const style = {
        minWidth: 40,
        border: 'none',
        width: 40
    }
    return <Button variant="contained" color={color} size="small" style={style} onClick={closeSnackbar}>
        OK
    </Button>
}

export default SnackbarCloseButton;
